<template>
  <div class="btn">
    <van-button
      :type="type"
      :class="getClassName"
      @click="handleClick"
      v-bind="$attrs"
    >
      <slot></slot>
    </van-button>
  </div>
</template>

<script>
import { Button } from 'vant'
export default {
  components: {
    [Button.name]: Button
  },
  computed: {
    getClassName () {
      if (this.originalStyle) return ''
      return this.type + ' ' + this.size
    }
  },
  props: {
    handleClick: {
      type: Function,
      default: () => {}
    },
    type: {
      type: String,
      default: 'info'
    },
    size: {
      type: String,
      default: 'mini'
    },
    originalStyle: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
  .btn{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
  }
  /deep/.van-button {
    margin: 0 auto;
    width: 90%;
    height: 100%;
    text-align: center;
    border-radius: 8px;
    font-size: 26px;
    font-weight: 600;
    padding: 18px 0;
    min-height: 60px;
  }
  /deep/.auto{
    min-height: 0 !important;
    font-size: 22px;
  }
  /deep/.info{
    background-color: #3378FF;
    color: #fff;
  }
  /deep/.default{
    background-color: #f5f7fa;
    color: #3e4966;
  }
  /deep/.danger{
    background-color: #bd3124;
    border: none;
    color: #fff;
  }
</style>
